import { API_URL } from '../config';
import { readStoredAddressCoordinates } from '../utils/addressCoordinates';

export async function productionRequest(path, { signal, body, method = 'GET' } = {}) {
  const response = await fetch(`${API_URL}/api/production${path}`, {
    method, signal,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}`, 'Content-Type': 'application/json' },
    ...(body !== undefined ? { body: JSON.stringify(body) } : {}),
  });
  const data = await response.json();
  if (!response.ok) throw new Error(typeof data.detail === 'string' ? data.detail : 'Не удалось получить данные производства');
  return data;
}

export const productionNumber = (value) => Number(value || 0).toLocaleString('ru-RU', { maximumFractionDigits: 1 });
export const productionDate = (value) => value
  ? new Date(`${value.slice(0, 10)}T12:00:00`).toLocaleDateString('ru-RU', { day: 'numeric', month: 'short' }) : '—';

export function draftProductionPayload(form, selfDeliveryDate = '', { noAddress = false } = {}) {
  const coordinates = readStoredAddressCoordinates(noAddress ? {} : (form.selectedAddress?.data || {}));
  const urgent = (form.items || []).some(item => item.isAdditional
    && (item.service_system_code || item.system_code) === 'urgent_order');
  return {
    service_type: form.serviceType === 'laundry' ? 'washing' : 'cleaning',
    arrival_date: (form.pickupType === 'self_delivery' ? selfDeliveryDate : form.pickupDate) || null,
    address_text: noAddress ? '' : String(form.selectedAddress?.value || form.address || '').trim(),
    latitude: coordinates.latitude, longitude: coordinates.longitude,
    priority: urgent ? 'urgent' : (form.priority || 'normal'),
    return_mode: form.returnDeliveryType === 'self_pickup' ? 'self_pickup' : 'delivery',
    items: (form.items || []).filter(item => !item.isAdditional).map(item => ({
      service_id: item.service_id || item.serviceId || null,
      item_name: item.name || item.serviceName || '',
      unit: item.unit || '', quantity: Number(item.quantity || 1),
      area: Number(item.area) > 0 ? Number(item.area) : null,
      weight: Number(item.weight) > 0 ? Number(item.weight) : null,
      processing_route_snapshot: item.processing_route_snapshot || item.processing_route || null,
    })),
  };
}
